import { PurchaseService } from "@/services/purchase-service";
import { InboxTypeState } from "./inbox-type-state";
import { Purchase } from "@/models/base";
import { AWSFileService } from "@/services";
import { InboxreaderService, InboxReaderType } from "@/services/inboxreader-service";
import { i18n } from "@/setup/i18n-setup";

export class InboxTypeStatePeppol extends InboxTypeState {
	protected getInboxTypes():InboxReaderType[]{
		return ["peppol"];
	}

	public async createPurchase():Promise<Purchase>{
		let p = this.selection[0];
		if (!p) throw new Error("Nothing selected");
		if (!p.PeppolOrder) throw new Error("No peppol order");
		let contactExists = await InboxreaderService.checkIfPeppolOrderContactExists(p.ID);
		if (!contactExists){
			let message = i18n.t("components.winbox.supplier-not-found", { supplier: p.PeppolOrder.Supplier.Name });
			let confirm = await this.vue.$confirmBuilder().setWarningTitle().setMessage(message).show();
			if (!confirm) throw new Error("No supplier");
		}
		let purchase = await PurchaseService.purchaseFromOrder(p.PeppolOrder);
		purchase.InboxreaderPurchaseID = p.ID;
		purchase.InboxreaderPurchaseMessageIDs = p.Files.map(p=>p.ID);

		for (let file of p.Files) {
			if (!file.File) continue;
			let { Token, Name } = file.File;
			if (!Name.toLowerCase().endsWith(".pdf") && file.File.ContentType.indexOf("pdf") != -1) {
				Name = Name + ".pdf";
			}
			const fetched = await AWSFileService.fetchFile(Token, Name, file.File.ContentType);
			purchase.UnprocessedFiles.push(fetched);
		}
		return purchase;
	}
}